import { useWindowSize } from "./use-window-size";

export function useIsWindowHorizontal() {
	const size = useWindowSize();
	return size.width > size.height;
}
